import { Text, VStack } from '@chakra-ui/react'

const QAItem = ({ question, answer }: { question: string; answer: string }) => {
  return (
    <VStack
      w={{
        base: '100%',
        md: 550
      }}
      alignItems="flex-start"
      gap={1}
      mt={3}
    >
      <Text textStyle="docQAQuestion">{question}</Text>

      <Text textStyle="docQAAnswer">{answer}</Text>
    </VStack>
  )
}

const QA = () => {
  return (
    <VStack py={10}>
      <Text
        w={{
          base: '100%',
          md: 550
        }}
        textStyle="docMainTitle"
      >
        FREQUENTLY ASKED QUESTIONS
      </Text>
      <QAItem
        question="It’s been a while since I applied, but I still feel something left on my skin. Has it been absorbed yet?"
        answer="If you feel something left on your skin, that could be the 3 layers water-veil system of our product to provides the moisture-protective film that allows your skin to breathe. It acts like a piece of seaweed that absorbs water and creates a water-protective film to keep moisture from evaporating."
      />
      <QAItem
        question="Can I put my make-up on after I wear the mask?"
        answer="When you mix Doctorcos 9 in 1 cream with BB cream or foundation in the correct ratio, you will have moisture and delicate make-up. That will be a good way to make luxurious and tight base make-up."
      />
      <QAItem
        question="The lustre was gone when I rubbed it."
        answer="The lustre would be reduced when you rub it. However, this is natural, as the product is not made with fat-soluble oil or artificial pearl powder. If you rub it on your face, the water- protective film will be thin. Put it on and let it be absorbed. With just pure moisturizer and water protective film, the results can be dazzling brilliance."
      />
    </VStack>
  )
}
export default QA
